import { useState, useEffect } from "react"
import { isEmptyObject } from "../../../services/utils/isEmptyObject"
import { sorts } from "../../../services/utils/sorts"
import windowService from "../../../services/WindowService"
import { buildParams } from "../../pages/ArtworksPage/utils/buildParams"
import { callArtworksResultsApi } from "./callArtworksResultsApi"
import { useInfinitePagination } from "../../actions/useInfinitePagination"
import galleryApiService from "../../../services/galleryApiService"

const totalFilters = (search) => {
  return Object.keys(search)
    .map((key) => search[key])
    .filter((val) => {
      return Array.isArray(val) ? val.length > 0 : !!val
    }).length
}

export const useArtworksResultsAction = ({ catalogData, setCatalogData }) => {
  const [loading, setLoading] = useState(false)
  const [firstRender, setFirstRender] = useState(true)
  const [showFilters, setShowFilters] = useState(false)
  const _sorts = sorts.artworks
  const [sort, setSort] = useState(null)
  const [search, setSearch] = useState({
    colors: [],
    collections: [],
    sizes: [],
    type: [],
    orientations: [],
    medium: [],
    material: [],
    minHeight: "",
    maxHeight: "",
    minWidth: "",
    maxWidth: "",
  })
  const [collapses, setCollapses] = useState({
    collections: false,
    sizes: false,
    type: false,
    orientations: false,
    medium: false,
    material: false,
    dimensions: false,
    colors: false,
  })

  const { setPage, setShouldCall } = useInfinitePagination(
    (page) => {
      let params = buildParams(search)
      return callArtworksResultsApi({ ...params, page })
    },
    (response) => {
      setCatalogData({
        ...catalogData,
        data: [...catalogData.data, ...response.data],
      })
    },
  )

  useEffect(() => {
    const params = buildParams(search, sort)
    if (!isEmptyObject(params)) {
      setLoading(true)
      setPage(1)
      setShouldCall(true)
      callArtworksResultsApi(params).then((response) => {
        setCatalogData(response.data.artworks)
        setLoading(false)
      })
    } else if (!firstRender) {
      callCleanApi()
    }
  }, [search, sort])

  useEffect(() => {
    setFirstRender(false)
  }, [])

  const clearFilters = () => {
    setSearch({
      colors: [],
      collections: [],
      sizes: [],
      type: [],
      orientations: [],
      medium: [],
      material: [],
      minHeight: "",
      maxHeight: "",
      minWidth: "",
      maxWidth: "",
    })
    callCleanApi()
  }

  const callCleanApi = () => {
    setPage(1)
    const params = buildParams(
      {
        colors: [],
        collections: [],
        sizes: [],
        type: [],
        orientations: [],
        medium: [],
        material: [],
        minHeight: "",
        maxHeight: "",
        minWidth: "",
        maxWidth: "",
      },
      sort,
    )
    setShouldCall(true)
    windowService.animatedScrollTop()
    setLoading(true)
    callArtworksResultsApi({ search: params.search }).then((response) => {
      console.log(response)
      setCatalogData(response.data.artworks)
      setLoading(false)
    })
  }

  const onClickString = (key, value) => {
    search[key] = value
    setSearch({ ...search })
  }

  const onClickArray = (key, value) => {
    const index = search[key].indexOf(value)

    if (index === -1) {
      search[key].push(value)
    } else {
      search[key].splice(index, 1)
    }

    setSearch({ ...search })
  }

  const onClickItem = (key, value) => {
    if (["minHeight", "maxHeight", "minWidth", "maxWidth"].includes(key)) {
      return onClickString(key, value)
    }

    return onClickArray(key, value)
  }

  const toggleExpand = (key) => {
    const _collapses = collapses
    _collapses[key] = !_collapses[key]
    setCollapses({ ..._collapses })
  }

  return {
    loading,
    setLoading,
    search,
    setSearch,
    collapses,
    setCollapses,
    clearFilters,
    onClickItem,
    toggleExpand,
    totalFilters: totalFilters(search),
    showFilters,
    setShowFilters,
    sort,
    setSort,
    sorts: _sorts,
  }
}
